import blogImg1 from '../Images/img50-1-e1706774753450.webp'
import blogImg2 from '../Images/img1258.webp'
import blogImg3 from '../Images/img1483.webp'
import blogImg4 from '../Images/Binghatti-Hills-E1-1.webp'
import blogImg5 from '../Images/Binghatti-Mirage-Apartments.webp'
import blogImg6 from '../Images/img6-scaled.webp'

export const blogsData = [
  // ============ مقال 1 ============
  {
    id: 1,
    slug: 'dubai-real-estate-guide-2026',
    title: {
      en: 'Your Complete Guide to Real Estate Investment in Dubai 2026',
      ar: 'دليلك الشامل للاستثمار العقاري في دبي 2026',
    },
    excerpt: {
      en: 'Everything you need to know before deciding on your real estate investment in Dubai, from choosing the area to calculating ROI.',
      ar: 'كل ما تحتاج معرفته قبل اتخاذ قرار الاستثمار في السوق العقاري بدبي.',
    },
    content: {
      en: `Dubai's real estate market has become one of the most attractive destinations for global investors in 2026. With zero property tax, strong rental yields, and world-class infrastructure, the emirate continues to outperform major cities like London, New York, and Singapore.

**Why Dubai?**
Dubai offers a unique combination of tax-free income, high rental returns (averaging 6-8% annually), and a safe, well-regulated market overseen by RERA. Foreign investors can own freehold properties in designated zones, and the Golden Visa program provides 10-year residency for those investing AED 2 million or more.

**Choosing the right area**
The best investment areas depend on your goal. For high rental yields, look at Dubai Marina, JLT, and Business Bay. For capital appreciation, Downtown Dubai and Palm Jumeirah remain top performers. For affordable entry, consider Dubai South, JVC, and Arjan.

**Understanding payment plans**
Most off-plan properties offer flexible payment plans — typically 60/40 or 70/30 — where you pay a percentage during construction and the rest on handover. This allows investors to enter the market with a smaller upfront capital.

**Calculating your ROI**
Rental yield = (Annual Rent ÷ Property Price) × 100. For example, a AED 1 million apartment rented for AED 70,000 per year delivers a 7% gross yield. Subtract service charges and maintenance to get your net yield.

**Final thoughts**
Dubai remains one of the safest and most rewarding real estate markets in the world. Whether you're investing for rental income, capital growth, or residency, the key is to work with a trusted broker who understands the market inside out.`,
      ar: `سوق العقارات في دبي أصبح واحد من أكثر الأسواق جذبًا للمستثمرين العالميين في 2026. مع عدم وجود ضريبة عقارية، وعوائد إيجارية قوية، وبنية تحتية عالمية، الإمارة مستمرة في التفوق على مدن كبرى زي لندن ونيويورك وسنغافورة.

**ليه دبي؟**
دبي بتوفر مزيج فريد من الدخل المعفى من الضرائب، عوائد إيجارية مرتفعة (متوسط 6-8% سنويًا)، وسوق آمن ومنظم تحت إشراف RERA. المستثمرين الأجانب يقدروا يمتلكوا عقارات freehold في مناطق مخصصة، وبرنامج الإقامة الذهبية بيوفر إقامة 10 سنوات لمن يستثمر 2 مليون درهم أو أكثر.

**اختيار المنطقة الصح**
أفضل مناطق الاستثمار بتعتمد على هدفك. للعوائد الإيجارية العالية، بص على دبي مارينا، JLT، وخليج الأعمال. لنمو رأس المال، داون تاون دبي ونخلة جميرا لسه في المقدمة. للميزانية الأقل، فكر في دبي الجنوب، JVC، وأرجان.

**فهم خطط السداد**
معظم العقارات على الخارطة بتوفر خطط سداد مرنة — عادة 60/40 أو 70/30 — بتدفع نسبة أثناء الإنشاء والباقي عند التسليم. ده بيسمح للمستثمرين يدخلوا السوق برأس مال أقل.

**حساب العائد على الاستثمار**
العائد الإيجاري = (الإيجار السنوي ÷ سعر العقار) × 100. مثلًا، شقة بمليون درهم تُأجر بـ 70,000 درهم سنويًا بتحقق عائد 7%. اطرح رسوم الخدمات والصيانة للحصول على العائد الصافي.

**الخلاصة**
دبي لسه واحدة من أأمن وأكثر أسواق العقارات ربحية في العالم. سواء بتستثمر للإيجار، نمو رأس المال، أو الإقامة، المفتاح هو التعامل مع وسيط موثوق يفهم السوق من الداخل.`,
    },
    date: '2026-09-10',
    dateDisplay: { en: 'September 10, 2026', ar: '10 سبتمبر 2026' },
    category: { en: 'Investment', ar: 'استثمار' },
    author: { en: 'Lyor Aura Team', ar: 'فريق ليور أورا' },
    readTime: 6,
    image: blogImg1,
    featured: true,
  },

  // ============ مقال 2 ============
  {
    id: 2,
    slug: 'emerging-areas-2026',
    title: {
      en: 'Best Emerging Areas to Invest in This Year',
      ar: 'أفضل المناطق الناشئة للاستثمار هذا العام',
    },
    excerpt: {
      en: 'A look at the areas witnessing rapid growth in demand and prices.',
      ar: 'نظرة على المناطق اللي بتشهد نمو سريع في الطلب والأسعار.',
    },
    content: {
      en: `While Dubai's prime areas like Downtown and Marina remain popular, savvy investors are turning their attention to emerging neighborhoods where prices are still accessible and growth potential is enormous.

**Dubai South**
Home to the Expo 2020 site and Al Maktoum International Airport, Dubai South is poised for massive growth. Prices remain 40-50% lower than central Dubai, making it ideal for first-time investors. The area is expected to add over 100,000 new residents by 2030.

**Jumeirah Village Circle (JVC)**
JVC has matured into a self-sustained community with over 2 million sq.ft of retail, schools, and parks. Rental yields here average 8-9%, among the highest in Dubai.

**Arjan**
Located near Dubai Miracle Garden, Arjan offers affordable apartments with strong rental demand. The area has seen 15% price growth in the past year alone.

**Dubai Hills Estate**
An upscale master community by Emaar, Dubai Hills combines luxury villas with modern apartments. It's ideal for families seeking space and greenery without leaving the city.

**Meydan**
Meydan has rapidly become a hotspot thanks to Mohammed Bin Rashid City developments. New launches by top developers are drawing both end-users and investors.

**Why emerging areas?**
These areas offer lower entry prices, higher rental yields, and significant appreciation potential as infrastructure catches up. For investors with a 3-5 year horizon, they represent some of the best opportunities in Dubai today.`,
      ar: `بينما المناطق الراقية في دبي زي داون تاون ومارينا لسه محبوبة، المستثمرين الأذكياء بدأوا يحوّلوا انتباههم لمناطق ناشئة حيث الأسعار لسه في المتناول وإمكانيات النمو هائلة.

**دبي الجنوب**
موطن موقع إكسبو 2020 ومطار آل مكتوم الدولي، دبي الجنوب على وشك نمو ضخم. الأسعار لسه أقل 40-50% من وسط دبي، مما بيخليها مثالية للمستثمرين الجدد. المنطقة متوقع تضيف أكثر من 100,000 ساكن جديد بحلول 2030.

**قرية جميرا الدائرية (JVC)**
JVC بقت مجتمع مكتمل بذاته فيه أكثر من 2 مليون قدم مربع تجزئة ومدارس وحدائق. العوائد الإيجارية هنا بمتوسط 8-9%، من الأعلى في دبي.

**أرجان**
قريبة من حديقة الزهور، أرجان بتوفر شقق بأسعار معقولة مع طلب إيجاري قوي. المنطقة شهدت نمو أسعار 15% في السنة الأخيرة بس.

**دبي هيلز إستيت**
مجتمع راقٍ من إعمار، دبي هيلز بيجمع بين الفلل الفاخرة والشقق العصرية. مثالي للعائلات اللي بتبحث عن مساحة وخضرة من غير ما تسيب المدينة.

**ميدان**
ميدان بسرعة بقت نقطة جذب بفضل تطورات محمد بن راشد سيتي. الإطلاقات الجديدة من كبار المطورين بتجذب المستخدمين النهائيين والمستثمرين.

**ليه المناطق الناشئة؟**
المناطق دي بتوفر أسعار دخول أقل، عوائد إيجارية أعلى، وإمكانيات ارتفاع كبيرة مع تطور البنية التحتية. للمستثمرين بأفق 3-5 سنين، بتمثل من أفضل الفرص في دبي حاليًا.`,
    },
    date: '2026-09-02',
    dateDisplay: { en: 'September 2, 2026', ar: '2 سبتمبر 2026' },
    category: { en: 'Market Analysis', ar: 'تحليل السوق' },
    author: { en: 'Lyor Aura Team', ar: 'فريق ليور أورا' },
    readTime: 5,
    image: blogImg2,
    featured: false,
  },

  // ============ مقال 3 ============
  {
    id: 3,
    slug: 'mortgage-steps-guide',
    title: {
      en: 'Financing Steps for Buying Property: Residents & Non-Residents',
      ar: 'خطوات تمويل شراء العقار للمقيمين وغير المقيمين',
    },
    excerpt: {
      en: 'A simplified explanation of mortgage procedures and bank requirements in the UAE.',
      ar: 'شرح مبسط لإجراءات الرهن العقاري ومتطلبات البنوك في الإمارات.',
    },
    content: {
      en: `Financing a property in the UAE is easier than many people think — especially with the wide range of mortgage products available from local and international banks.

**Who can get a mortgage?**
Both UAE residents and non-residents can apply. Residents typically qualify for up to 80% financing (85% for UAE nationals), while non-residents can secure up to 65% depending on the bank.

**Step 1: Check your eligibility**
Banks consider your salary, employment stability, existing debts, and credit score. The maximum you can borrow is usually capped at 50% of your monthly income (Debt Burden Ratio).

**Step 2: Get pre-approved**
Before you start viewing properties, get a mortgage pre-approval from a bank. This tells you exactly how much you can borrow and strengthens your negotiation position.

**Step 3: Choose your property**
Once you've chosen a property (off-plan or ready), you'll need to provide the sales agreement, developer details, and property specifications to the bank.

**Step 4: Property valuation**
The bank arranges an independent valuation to confirm the property's market value. This usually costs AED 2,500 - AED 3,500.

**Step 5: Final approval & signing**
Once approved, you'll sign the mortgage agreement, pay the down payment, and the bank releases funds to the developer or seller.

**Typical costs**
- Down payment: 20-35% of property value
- Bank arrangement fee: 1% of loan
- Property valuation: AED 2,500-3,500
- DLD transfer fee: 4% of property value
- Mortgage registration: 0.25% of loan

**Final tip**
Work with a mortgage broker who can compare offers from multiple banks and negotiate the best rate for your profile.`,
      ar: `تمويل عقار في الإمارات أسهل مما يتصور كتير — خصوصًا مع تنوع منتجات الرهن العقاري المتاحة من البنوك المحلية والدولية.

**مين يقدر يحصل على تمويل؟**
المقيمين وغير المقيمين يقدروا يقدموا. المقيمين عادة بيحصلوا على تمويل لحد 80% (85% لمواطني الإمارات)، وغير المقيمين لحد 65% حسب البنك.

**الخطوة 1: تحقق من أهليتك**
البنوك بتدرس راتبك، استقرار الوظيفة، الديون الحالية، والتصنيف الائتماني. أقصى مبلغ تقدر تقترضه عادة محدد بـ 50% من دخلك الشهري (نسبة العبء Debt Burden Ratio).

**الخطوة 2: الحصول على موافقة مبدئية**
قبل ما تبدأ تشوف عقارات، احصل على موافقة مبدئية من البنك. ده بيقولك بالظبط كم تقدر تقترض وبيقوّي موقفك في التفاوض.

**الخطوة 3: اختار عقارك**
بعد ما تختار العقار (على الخارطة أو جاهز)، هتحتاج تقدم عقد البيع، بيانات المطور، ومواصفات العقار للبنك.

**الخطوة 4: تقييم العقار**
البنك بترتب تقييم مستقل لتأكيد القيمة السوقية. ده عادة بيكلف 2,500 - 3,500 درهم.

**الخطوة 5: الموافقة النهائية والتوقيع**
بعد الموافقة، هتوقع عقد الرهن، تدفع الدفعة المقدمة، والبنك بيصرف المبلغ للمطور أو البائع.

**التكاليف المعتادة**
- دفعة مقدمة: 20-35% من قيمة العقار
- رسوم ترتيب البنك: 1% من القرض
- تقييم العقار: 2,500-3,500 درهم
- رسوم نقل ملكية دبي: 4% من قيمة العقار
- تسجيل الرهن: 0.25% من القرض

**نصيحة أخيرة**
اشتغل مع وسيط رهن عقاري يقدر يقارن العروض من بنوك مختلفة ويتفاوض على أفضل سعر لملفك.`,
    },
    date: '2026-08-28',
    dateDisplay: { en: 'August 28, 2026', ar: '28 أغسطس 2026' },
    category: { en: 'Financing', ar: 'تمويل' },
    author: { en: 'Lyor Aura Team', ar: 'فريق ليور أورا' },
    readTime: 7,
    image: blogImg3,
    featured: false,
  },

  // ============ مقال 4 ============
  {
    id: 4,
    slug: 'off-plan-vs-ready',
    title: {
      en: 'Off-Plan vs Ready Properties: Which Fits You?',
      ar: 'العقارات تحت الإنشاء مقابل الجاهزة: أنهي تناسبك؟',
    },
    excerpt: {
      en: 'Comparing the pros and cons of buying off-plan versus ready properties in Dubai.',
      ar: 'مقارنة بين مميزات وعيوب شراء عقار تحت الإنشاء أو عقار جاهز في دبي.',
    },
    content: {
      en: `One of the most common questions we hear from buyers is: should I buy off-plan or ready? The answer depends entirely on your goals, timeline, and risk tolerance.

**Off-Plan Properties**
These are properties bought before or during construction, with handover typically 1-3 years away.

Advantages:
- Lower prices (typically 10-20% below ready units)
- Flexible payment plans spread over construction
- Choice of the best units (highest floors, best views)
- Higher capital appreciation by handover

Disadvantages:
- You can't move in immediately
- Risk if developer delays delivery
- Market conditions may change by handover

**Ready Properties**
These are completed units you can move into or rent out immediately.

Advantages:
- Immediate rental income
- Physical inspection before purchase
- No construction risk
- Mortgage easier to obtain

Disadvantages:
- Higher price per sq.ft
- Fewer payment plan options
- Best units often already sold

**Which is right for you?**
Choose off-plan if you have a 3-5 year horizon, want to maximize returns, and can wait for handover. Choose ready if you need immediate income, want certainty, or plan to live in the property soon.

**Our recommendation**
Many smart investors use both. Buy off-plan for long-term appreciation, and ready properties for immediate cash flow. This strategy balances risk and reward perfectly.`,
      ar: `من أكثر الأسئلة اللي بنسمعها من المشترين: أشتري على الخارطة ولا جاهز؟ الإجابة بتعتمد كليًا على أهدافك، إطارك الزمني، وقدرتك على تحمل المخاطر.

**العقارات على الخارطة**
دي عقارات بتُشترى قبل أو أثناء الإنشاء، مع تسليم عادة بعد 1-3 سنين.

المميزات:
- أسعار أقل (عادة 10-20% تحت الجاهز)
- خطط سداد مرنة موزعة على فترة الإنشاء
- اختيار أفضل الوحدات (أعلى الطوابق، أفضل الإطلالات)
- ارتفاع أكبر في رأس المال عند التسليم

العيوب:
- مش هتقدر تسكن فورًا
- مخاطرة لو المطور أخّر التسليم
- ظروف السوق ممكن تتغير عند التسليم

**العقارات الجاهزة**
دي وحدات مكتملة تقدر تسكن أو تأجرها فورًا.

المميزات:
- دخل إيجاري فوري
- معاينة فعلية قبل الشراء
- بدون مخاطرة إنشاءات
- الرهن العقاري أسهل في الحصول عليه

العيوب:
- سعر أعلى للقدم المربع
- خيارات خطط سداد أقل
- أفضل الوحدات غالبًا اتباعت

**أنهي المناسب ليك؟**
اختار على الخارطة لو عندك أفق 3-5 سنين، عايز تعظّم العائد، وتقدر تستنى التسليم. اختار جاهز لو محتاج دخل فوري، عايز يقين، أو بتخطط تسكن قريب.

**توصيتنا**
كتير من المستثمرين الأذكياء بيستخدموا الاتنين. اشتري على الخارطة لارتفاع طويل المدى، وجاهز للتدفق النقدي الفوري. الاستراتيجية دي بتوازن المخاطر والمكافآت بشكل مثالي.`,
    },
    date: '2026-08-20',
    dateDisplay: { en: 'August 20, 2026', ar: '20 أغسطس 2026' },
    category: { en: 'Investment', ar: 'استثمار' },
    author: { en: 'Lyor Aura Team', ar: 'فريق ليور أورا' },
    readTime: 6,
    image: blogImg4,
    featured: false,
  },

  // ============ مقال 5 ============
  {
    id: 5,
    slug: 'service-charges-guide',
    title: {
      en: 'Understanding Service Charges in Dubai Properties',
      ar: 'فهم رسوم الخدمات في العقارات بدبي',
    },
    excerpt: {
      en: 'What service charges cover, how they are calculated, and what to expect as an owner.',
      ar: 'ما هي رسوم الخدمات، وكيف يتم حسابها، وماذا تتوقع كمالك.',
    },
    content: {
      en: `Service charges are one of the most misunderstood costs of property ownership in Dubai. Understanding them properly helps you avoid surprises and make smarter investment decisions.

**What are service charges?**
Service charges are the annual fees paid by property owners to maintain the building's common areas and shared facilities. They are calculated based on your property's square footage.

**What do they cover?**
- Cleaning and maintenance of common areas
- Security and concierge
- Elevator maintenance
- Pool, gym, and landscaping
- Insurance for common areas
- Building management fees
- Utilities for common areas

**How are they calculated?**
The RERA-approved service charge is calculated by dividing the total annual cost of maintaining the building by the total square footage of all units. Each owner pays a share proportional to their unit size.

**Typical rates in Dubai**
- Apartments: AED 12-25 per sq.ft per year
- Villas: AED 3-8 per sq.ft per year
- Luxury properties: AED 25-40 per sq.ft per year
- Commercial: AED 20-50 per sq.ft per year

**Example**
A 1,200 sq.ft apartment at AED 18/sq.ft pays AED 21,600 annually, or AED 1,800 per month.

**Why it matters for investors**
Always include service charges when calculating your net rental yield. A 7% gross yield can drop to 5% net after service charges and maintenance.

**What if charges seem too high?**
You can request the budget breakdown from the building's owners' association. If charges seem unreasonable, you can raise the matter with RERA.`,
      ar: `رسوم الخدمات واحدة من أكثر التكاليف اللي بتُفهم غلط في ملكية العقارات بدبي. فهمها صح بيساعدك تتجنب المفاجآت وتاخد قرارات استثمارية أذكى.

**إيه هي رسوم الخدمات؟**
رسوم الخدمات هي المبالغ السنوية اللي بيدفعها أصحاب العقارات لصيانة المناطق المشتركة والمرافق المشتركة في المبنى. بتُحسب على أساس المساحة بالقدم المربع.

**بتغطي إيه؟**
- تنظيف وصيانة المناطق المشتركة
- الأمن والكونسيرج
- صيانة المصاعد
- المسبح والصالة الرياضية وتنسيق الحدائق
- تأمين المناطق المشتركة
- رسوم إدارة المبنى
- مرافق المناطق المشتركة

**كيف بتُحسب؟**
رسوم الخدمات المعتمدة من RERA بتُحسب بقسمة التكلفة السنوية الإجمالية لصيانة المبنى على إجمالي المساحة المربعة لكل الوحدات. كل مالك بيدفع حصة متناسبة مع حجم وحدته.

**المعدلات المعتادة في دبي**
- الشقق: 12-25 درهم للقدم المربع سنويًا
- الفلل: 3-8 درهم للقدم المربع سنويًا
- العقارات الفاخرة: 25-40 درهم للقدم المربع سنويًا
- التجارية: 20-50 درهم للقدم المربع سنويًا

**مثال**
شقة 1,200 قدم مربع بـ 18 درهم للقدم بتدفع 21,600 درهم سنويًا، أو 1,800 درهم شهريًا.

**ليه مهمة للمستثمرين**
دايمًا ضمّن رسوم الخدمات لما تحسب العائد الإيجاري الصافي. عائد 7% إجمالي ممكن ينزل لـ 5% صافي بعد رسوم الخدمات والصيانة.

**لو الرسوم بتبان عالية؟**
تقدر تطلب تفصيل الميزانية من جمعية ملاك المبنى. لو الرسوم بتبان غير معقولة، تقدر ترفع الأمر لـ RERA.`,
    },
    date: '2026-08-12',
    dateDisplay: { en: 'August 12, 2026', ar: '12 أغسطس 2026' },
    category: { en: 'Ownership', ar: 'ملكية' },
    author: { en: 'Lyor Aura Team', ar: 'فريق ليور أورا' },
    readTime: 5,
    image: blogImg5,
    featured: false,
  },

  // ============ مقال 6 ============
  {
    id: 6,
    slug: 'golden-visa-guide',
    title: {
      en: 'Golden Visa Through Real Estate Investment',
      ar: 'الحصول على الإقامة الذهبية عن طريق الاستثمار العقاري',
    },
    excerpt: {
      en: 'Requirements and steps to obtain the UAE Golden Visa through property investment.',
      ar: 'الشروط والخطوات للحصول على الإقامة الذهبية في الإمارات عن طريق الاستثمار العقاري.',
    },
    content: {
      en: `The UAE Golden Visa is one of the most valuable residency programs in the world, offering 10-year renewable residency for investors, entrepreneurs, and talented professionals. Real estate investment is one of the easiest ways to qualify.

**What is the Golden Visa?**
Introduced in 2019, the Golden Visa grants long-term residency (5 or 10 years, renewable) without the need for a national sponsor. It covers you, your spouse, children, and domestic workers.

**Real estate investment requirement**
To qualify through property, you must own property in the UAE worth at least AED 2 million. The property can be:
- A single ready property worth AED 2 million or more
- Multiple properties totaling AED 2 million
- An off-plan property with a paid amount of at least AED 2 million

**Key benefits**
- 10-year renewable residency
- No sponsor required
- Can sponsor spouse, children, and domestic workers
- Can stay outside UAE for more than 6 months without losing residency
- Can open bank accounts and do business easily
- Path to UAE citizenship in some cases

**Required documents**
- Passport copy
- Emirates ID (if resident)
- Property title deed or off-plan contract
- Property valuation certificate from a Dubai Land Department-approved evaluator
- Proof of payment (minimum AED 2 million)
- Medical fitness test
- Health insurance

**Steps to apply**
1. Purchase a qualifying property (AED 2 million+)
2. Get the property valued by an approved evaluator
3. Submit the application through ICP (Federal Authority for Identity and Citizenship)
4. Pay the fees (approximately AED 4,000-6,000)
5. Receive your Golden Visa

**Why it matters**
For investors, the Golden Visa transforms a property purchase into a long-term residency plan — perfect for families, business owners, and global citizens seeking stability in the UAE.`,
      ar: `الإقامة الذهبية الإماراتية واحدة من أكثر برامج الإقامة قيمة في العالم، بتوفر إقامة 10 سنين قابلة للتجديد للمستثمرين ورواد الأعمال والمواهب المتميزة. الاستثمار العقاري واحد من أسهل الطرق للتأهل.

**إيه هي الإقامة الذهبية؟**
اتقدمت في 2019، الإقامة الذهبية بتمنح إقامة طويلة المدى (5 أو 10 سنين، قابلة للتجديد) من غير الحاجة لكفيل وطني. بتشمل الزوج/الزوجة، الأولاد، والعمالة المنزلية.

**شرط الاستثمار العقاري**
للتأهل من خلال العقار، لازم تمتلك عقار في الإمارات بقيمة 2 مليون درهم على الأقل. العقار ممكن يكون:
- عقار جاهز واحد بقيمة 2 مليون درهم أو أكثر
- عدة عقارات بإجمالي 2 مليون درهم
- عقار على الخارطة بمبلغ مدفوع 2 مليون درهم على الأقل

**المزايا الأساسية**
- إقامة 10 سنين قابلة للتجديد
- بدون كفيل
- تقدر تكفل الزوجة والأولاد والعمالة المنزلية
- تقدر تبقى برة الإمارات أكثر من 6 شهور بدون ما تفقد الإقامة
- تفتح حسابات بنكية وتعمل بسهولة
- مسار للحصول على الجنسية الإماراتية في بعض الحالات

**المستندات المطلوبة**
- صورة الجواز
- الهوية الإماراتية (لو مقيم)
- سند ملكية العقار أو عقد على الخارطة
- شهادة تقييم العقار من مُقيّم معتمد من دائرة الأراضي والأملاك
- إثبات الدفع (2 مليون درهم على الأقل)
- فحص اللياقة الطبية
- تأمين صحي

**خطوات التقديم**
1. اشتري عقار مؤهل (2 مليون درهم+)
2. احصل على تقييم العقار من مُقيّم معتمد
3. قدّم الطلب من خلال الهيئة الاتحادية للهوية والجنسية (ICP)
4. ادفع الرسوم (حوالي 4,000-6,000 درهم)
5. استلم الإقامة الذهبية

**ليه مهمة؟**
للمستثمرين، الإقامة الذهبية بتحوّل شراء العقار لخطة إقامة طويلة المدى — مثالية للعائلات، أصحاب الأعمال، والمواطنين العالميين اللي بيدوروا على استقرار في الإمارات.`,
    },
    date: '2026-08-05',
    dateDisplay: { en: 'August 5, 2026', ar: '5 أغسطس 2026' },
    category: { en: 'Legal', ar: 'قانوني' },
    author: { en: 'Lyor Aura Team', ar: 'فريق ليور أورا' },
    readTime: 7,
    image: blogImg6,
    featured: false,
  },
]

export const getUniqueCategories = (lang = 'ar') =>
  [...new Set(blogsData.map((b) => b.category[lang]))]

export const getBlogBySlug = (slug) =>
  blogsData.find((b) => b.slug === slug)